import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useCallback
} from "react";

import { toast } from "react-toastify";
import "./mobile-styles.css";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Paper,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Box,
  Chip,
  Grid,
  Collapse,
  useMediaQuery,
  Menu,
  MenuItem,
  Fab,
  Slide,
  ClickAwayListener,
  Tooltip,
  ButtonGroup
} from "@material-ui/core";
import {
  Menu as MenuIcon,
  Close as CloseIcon,
  Add as AddIcon,
  ExpandLess,
  ExpandMore,
  Save as SaveIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  ChevronLeft,
  ChevronRight
} from "@material-ui/icons";
import WebAssetIcon from '@material-ui/icons/WebAsset';
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import toastError from "../../errors/toastError";

import HttpIcon from "@mui/icons-material/Http";
import DataObjectIcon from "@mui/icons-material/DataObject";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import CompareArrows from "@mui/icons-material/CompareArrows";

import ReactFlow, {
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
  useReactFlow
} from "react-flow-renderer";

import {
  AccessTime,
  CallSplit,
  DynamicFeed,
  Image,
  ImportExport,
  LibraryBooks,
  Message,
  MicNone,
  RocketLaunch,
  Videocam,
  Tag,
  Queue,
  Person,
  SmartButton,
  AutoAwesome
} from "@mui/icons-material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';

// Import dos nós (mantendo os mesmos)
import messageNode from "./nodes/messageNode.js";
import startNode from "./nodes/startNode";
import openaiNode from "./nodes/openaiNode";
import geminiNode from "./nodes/geminiNode";
//import conditionNode from "./nodes/conditionNode";
import menuNode from "./nodes/menuNode";
import interactiveNode from "./nodes/interactiveNode";
import intervalNode from "./nodes/intervalNode";
import imgNode from "./nodes/imgNode";
import randomizerNode from "./nodes/randomizerNode";
import videoNode from "./nodes/videoNode";
import switchFlowNode from "./nodes/switchFlowNode";
import attendantNode from "./nodes/attendantNode";
import RemoveEdge from "./nodes/removeEdge";
import audioNode from "./nodes/audioNode";
import { useNodeStorage } from "../../stores/useNodeStorage";
import singleBlockNode from "./nodes/singleBlockNode";
import ticketNode from "./nodes/ticketNode";
import tagNode from "./nodes/tagNode";
import conditionCompareNode from "./nodes/conditionCompareNode";
import HttpRequestNode from "./nodes/httpRequestNode";
import removeTagNode from "./nodes/removeTagNode";
import addKanbanNode from "./nodes/addKanbanNode";
import removeKanbanNode from "./nodes/removeKanbanNode";
import VariableNode, {
  getFlowVariable,
  setFlowVariable,
} from "./nodes/variableNode";
import inputNode from "./nodes/inputNode";

// Imports dos modais (mantendo os mesmos)
import FlowBuilderAddImgModal from "../../components/FlowBuilderAddImgModal";
import FlowBuilderTicketModal from "../../components/FlowBuilderAddTicketModal";
import FlowBuilderAddAudioModal from "../../components/FlowBuilderAddAudioModal";
import FlowBuilderAddTagModal from "../../components/FlowBuilderAddTagModal";
import FlowBuilderRandomizerModal from "../../components/FlowBuilderRandomizerModal";
import FlowBuilderAddVideoModal from "../../components/FlowBuilderAddVideoModal";
import FlowBuilderSingleBlockModal from "../../components/FlowBuilderSingleBlockModal";
import FlowBuilderAddTextModal from "../../components/FlowBuilderAddTextModal";
import FlowBuilderIntervalModal from "../../components/FlowBuilderIntervalModal";
//import FlowBuilderConditionModal from "../../components/FlowBuilderConditionModal";
import FlowBuilderMenuModal from "../../components/FlowBuilderMenuModal";
import FlowBuilderInteractiveModal from "../../components/FlowBuilderInteractiveModal";
import FlowBuilderAddSwitchFlowModal from "../../components/FlowBuilderAddSwitchFlowModal";
import FlowBuilderAddAttendantModal from "../../components/FlowBuilderAddAttendantModal";
import FlowBuilderInputModal from "../../components/FlowBuilderInputModal";
import FlowBuilderConditionCompareModal from "../../components/FlowBuilderConditionCompareModal";
import FlowBuilderRemoveTagModal from "../../components/FlowBuilderRemoveTagModal";
import FlowBuilderAddKanbanModal from "../../components/FlowBuilderAddKanbanModal";
import FlowBuilderRemoveKanbanModal from "../../components/FlowBuilderRemoveKanbanModal";
import FlowBuilderOpenAIModal from "../../components/FlowBuilderAddOpenAIModal";
import FlowBuilderGeminiModal from "../../components/FlowBuilderGeminiModal";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { CircularProgress } from "@material-ui/core";



const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    overflow: "hidden",
    background: theme.palette.type === "dark" ? "#090D0A" : "#EFF4F1"
  },
  header: {
    flexShrink: 0,
    background: theme.palette.type === "dark" ? "#0B100D" : "#FFFFFF",
    borderBottom: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#D9E5DE"}`,
    boxShadow: "0 6px 24px rgba(10,35,22,.06)",
    zIndex: 1201
  },
  content: {
    flex: 1,
    display: "flex",
    position: "relative",
    overflow: "hidden"
  },
  // Sidebar colapsável para desktop
  sidebar: {
    width: props => props.sidebarOpen ? 326 : 64,
    background: theme.palette.type === "dark" ? "#101713" : "#FBFDFC",
    borderRight: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#D9E5DE"}`,
    transition: "width 0.3s ease",
    display: "flex",
    flexDirection: "column",
    zIndex: 1000,
    boxShadow: "10px 0 34px rgba(10,35,22,.065)",
    [theme.breakpoints.down('md')]: {
      display: "none" // Ocultar sidebar em mobile
    }
  },
  sidebarHeader: {
    padding: theme.spacing(1.5, 1.6),
    borderBottom: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#D9E5DE"}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 66,
    background: theme.palette.type === "dark" ? "#111A14" : "linear-gradient(135deg,#F7FBF8,#EEF7F2)",
    color: theme.palette.type === "dark" ? "#F4FAF6" : "#14241B"
  },
  sidebarContent: {
    flex: 1,
    overflowY: "auto",
    background: theme.palette.type === "dark" ? "#101713" : "#FBFDFC",
    padding: theme.spacing(1.25),
    ...theme.scrollbarStyles
  },
  flowContainer: {
    flex: 1,
    position: "relative",
    background: theme.palette.type === 'dark'
      ? 'radial-gradient(circle at 50% 0%, rgba(0,219,117,.055), transparent 34%), #0B100D'
      : 'radial-gradient(circle at 50% 0%, rgba(0,168,90,.08), transparent 35%), #E8EEEA',
    '& .react-flow__controls': {
      zIndex: 1100, // Garantir que fique acima de outros elementos
      bottom: theme.spacing(2),
      left: theme.spacing(2),
      borderRadius: 12,
      overflow: "hidden",
      border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.12)" : "#CFE0D6"}`,
      boxShadow: "0 10px 28px rgba(10,35,22,.13)",
      '& button': {
        background: theme.palette.type === "dark" ? "#121B15" : "#FFFFFF",
        color: theme.palette.type === "dark" ? "#E7F5EC" : "#173024",
        borderBottomColor: theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#E2EBE5",
      },
      [theme.breakpoints.down('md')]: {
        display: 'none' // Ocultar em mobile já que temos controles customizados
      }
    },
    '& .react-flow__minimap': {
      borderRadius: 14,
      overflow: "hidden",
      border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.12)" : "#CFE0D6"}`,
      boxShadow: "0 10px 28px rgba(10,35,22,.11)",
      background: theme.palette.type === "dark" ? "#101713" : "#FFFFFF",
    }
  },
  canvasLegend: {
    position: "absolute", top: 16, left: 18, zIndex: 1050,
    display: "flex", alignItems: "center", gap: 10, pointerEvents: "none",
    padding: "9px 12px", borderRadius: 12,
    background: theme.palette.type === "dark" ? "rgba(16,23,19,.88)" : "rgba(255,255,255,.90)",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.10)" : "#D6E4DC"}`,
    boxShadow: "0 10px 28px rgba(10,35,22,.08)", backdropFilter: "blur(10px)",
  },
  canvasLegendBadge: { fontSize: 9, fontWeight: 900, letterSpacing: "1px", color: "#007A42", background: "rgba(0,219,117,.13)", borderRadius: 99, padding: "4px 7px" },
  canvasLegendText: { fontSize: 12, fontWeight: 750, color: theme.palette.type === "dark" ? "#EAF5EE" : "#294036" },
  // Bottom sheet para mobile
  bottomSheet: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.background.paper,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    boxShadow: theme.shadows[8],
    zIndex: 1500,
    maxHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.up('lg')]: {
      display: "none" // Ocultar em desktop
    }
  },
  bottomSheetHandle: {
    width: 40,
    height: 4,
    backgroundColor: theme.palette.divider,
    borderRadius: 2,
    margin: "8px auto",
    cursor: "pointer"
  },
  bottomSheetHeader: {
    padding: theme.spacing(1, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: theme.palette.background.paper
  },
  bottomSheetContent: {
    flex: 1,
    overflowY: "auto",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    ...theme.scrollbarStyles
  },
  // Floating Action Button
  fab: {
    position: "fixed",
    top: 60, // Posicionar no topo, acima dos quickActions
    right: theme.spacing(2),
    zIndex: 1400,
    backgroundColor: "#00DB75",
    color: "#04130C",
    boxShadow: "0 12px 30px rgba(0,219,117,.30)",
    '&:hover': {
      backgroundColor: "#00C96C",
    },
    [theme.breakpoints.down('md')]: {
      bottom: theme.spacing(9),
      top: 'auto'
    }
  },
  addFab: {
    position: "fixed",
    bottom: theme.spacing(2),
    left: theme.spacing(2),
    zIndex: 1400,
    backgroundColor: "#07110C",
    color: "#00DB75",
    '&:hover': {
      backgroundColor: "#14251B",
    },
    [theme.breakpoints.up('lg')]: {
      display: "none"
    }
  },
  // Categorias de nós
  categoryButton: {
    margin: theme.spacing(0.5),
    textTransform: "none",
    borderRadius: theme.spacing(1),
    minWidth: "auto",
    fontSize: "0.75rem",
    color: theme.palette.text.primary,
    borderColor: theme.palette.divider
  },
  nodeButton: {
    justifyContent: "flex-start",
    textTransform: "none",
    padding: theme.spacing(1.15, 1.25),
    marginBottom: theme.spacing(0.65),
    borderRadius: 12,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.075)" : "#E1EAE4"}`,
    background: theme.palette.type === "dark" ? "rgba(255,255,255,.025)" : "#FFFFFF",
    boxShadow: "0 3px 10px rgba(10,35,22,.035)",
    transition: "all 0.2s ease",
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: theme.palette.type === "dark" ? "rgba(0,219,117,.08)" : "#F5FBF7",
      borderColor: "rgba(0,168,90,.32)",
      boxShadow: "0 8px 18px rgba(10,35,22,.075)",
      transform: "translateX(3px)"
    },
    "& .MuiButton-startIcon": {
      width: 32,
      height: 32,
      marginLeft: 0,
      marginRight: 10,
      borderRadius: 9,
      background: theme.palette.type === "dark" ? "rgba(0,219,117,.09)" : "#EDF8F2",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1px solid rgba(0,168,90,.10)"
    },
    "& .MuiTypography-body2": {
      fontWeight: 800,
      fontSize: ".79rem",
      letterSpacing: "-.05px"
    },
    "& .MuiTypography-caption": {
      display: "block",
      marginTop: 2,
      fontSize: ".66rem",
      lineHeight: 1.25,
      color: theme.palette.type === "dark" ? "rgba(255,255,255,.52)" : "#718078"
    }
  },
  collapsedNodeButton: {
    width: 48,
    height: 48,
    minWidth: 48,
    padding: 0,
    margin: theme.spacing(0.5, 0.5),
    justifyContent: "center",
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    }
  },
  categoryHeader: {
    padding: theme.spacing(1.15, 1.25),
    marginBottom: theme.spacing(.75),
    borderRadius: 12,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#D8E5DD"}`,
    background: theme.palette.type === "dark" ? "rgba(255,255,255,.035)" : "linear-gradient(135deg,#F8FBF9,#EEF6F1)",
    fontWeight: 850,
    color: theme.palette.text.primary,
    cursor: "pointer",
    userSelect: "none",
    '&:hover': {
      background: theme.palette.type === "dark" ? "rgba(0,219,117,.08)" : "linear-gradient(135deg,#F3FAF6,#E5F3EA)",
      borderColor: "rgba(0,168,90,.25)",
      boxShadow: "0 5px 14px rgba(10,35,22,.055)"
    },
    "& .MuiTypography-body2": {
      fontWeight: 900,
      fontSize: ".75rem",
      letterSpacing: ".2px",
      textTransform: "uppercase"
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1.12rem"
    }
  },
  quickActions: {
    position: "fixed",
    top: 120,
    right: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    zIndex: 1200,
    [theme.breakpoints.down('md')]: {
      display: "none"
    }
  },
  quickActionButton: {
    backgroundColor: theme.palette.background.paper,
    backdropFilter: "blur(10px)",
    boxShadow: theme.shadows[3],
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.12)" : "#CFE0D6"}`,
    borderRadius: 11,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      transform: "scale(1.05)",
      boxShadow: theme.shadows[6]
    }
  },
  // Mobile controls
  mobileControls: {
    position: "fixed",
    bottom: 80,
    left: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    zIndex: 1300,
    [theme.breakpoints.up('lg')]: {
      display: "none"
    }
  },
  controlButton: {
    backgroundColor: theme.palette.background.paper,
    backdropFilter: "blur(10px)",
    boxShadow: theme.shadows[3],
    width: 48,
    height: 48,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      transform: "scale(1.05)"
    }
  },
  categoryCard: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 13,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#D9E5DE"}`,
    marginBottom: theme.spacing(1)
  },
  categoryTitle: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: theme.palette.text.primary
  },
  categoryNodeBtn: {
    width: "100%",
    marginBottom: theme.spacing(0.5),
    justifyContent: "flex-start",
    textTransform: "none",
    fontSize: "0.8rem",
    padding: theme.spacing(1.1, 1.5),
    borderRadius: 9,
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.type === "dark" ? "rgba(0,219,117,.08)" : "#EFF9F3",
    }
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "70vh",
    backgroundColor: theme.palette.background.paper
  }
}));

// Definição das categorias de nós
const nodeCategories = [
  {
    name: "Básicos",
    color: theme => theme.palette.primary.main,
    icon: <RocketLaunch />,
    nodes: [
      {
        icon: <RocketLaunch />,
        name: "Início",
        type: "start",
        description: "Ponto inicial do fluxo"
      }
    ]
  },
  {
    name: "Conteúdo",
    color: theme => theme.palette.success.main,
    icon: <LibraryBooks />,
    nodes: [
      {
        icon: <LibraryBooks />,
        name: "Conteúdo",
        type: "content",
        description: "Enviar texto, imagem, áudio ou vídeo"
      },
      {
        icon: <Message />,
        name: "Texto",
        type: "text",
        description: "Mensagem de texto simples"
      }
    ]
  },
  {
    name: "Interação",
    color: theme => theme.palette.warning.main,
    icon: <DynamicFeed />,
    nodes: [
      {
        icon: <DynamicFeed />,
        name: "Menu",
        type: "menu",
        description: "para quem utiliza WhatsApp QRCode"
      },
      {
        icon: <SmartButton />,
        name: "Menu de Opções Clicáveis",
        type: "interactiveMenu",
        description: "para quem utiliza WhatsApp API"
      },
      {
        icon: <QuestionAnswerIcon />,
        name: "Pergunta",
        type: "input",
        description: "Faz uma pergunta e espera o cliente responder pra continuar"
      },
      {
        icon: <AccessTime />,
        name: "Intervalo",
        type: "interval",
        description: "Pausar execução por tempo"
      }
    ]
  },
  {
    name: "Lógica",
    color: theme => theme.palette.secondary.main,
    icon: <CallSplit />,
    nodes: [
      {
        icon: <CallSplit />,
        name: "Randomizador",
        type: "random",
        description: "Escolha aleatória de caminhos"
      },
      {
        icon: <CompareArrows />,
        name: "Se/Senão (If/Else)",
        type: "conditionCompare",
        description: "Bifurcar fluxo com base em condição"
      }
    ]
  },
  {
    name: "Sistema",
    color: theme => theme.palette.info.main,
    icon: <Queue />,
    nodes: [
      {
        icon: <Queue />,
        name: "Filas",
        type: "ticket",
        description: "Gerenciar filas de atendimento"
      },
      {
        icon: <Tag />,
        name: "Tags",
        type: "tag",
        description: "Adicionar tags ao contato"
      },
      {
        icon: <Tag />,
        name: "Remover Tag",
        type: "removeTag",
        description: "Remover tags do contato"
      },
      {
        icon: <ViewWeekIcon />,
        name: "Adicionar Kanban",
        type: "addKanban",
        description: "Colocar ticket em lane do Kanban"
      },
      {
        icon: <ViewWeekIcon />,
        name: "Remover Kanban",
        type: "removeKanban",
        description: "Remover ticket do Kanban"
      },
      {
        icon: <ArrowForwardIcon />,
        name: "Trocar Flow",
        type: "switchFlow",
        description: "Direcionar para outro fluxo"
      },
      {
        icon: <Person />,
        name: "Atendente",
        type: "attendant",
        description: "Transferir para atendente"
      }
    ]
  },
  {
    name: "Integrações",
    color: theme => theme.palette.error.main,
    icon: <HttpIcon />,
    nodes: [
      {
        icon: <HttpIcon />,
        name: "HTTP Request",
        type: "httpRequest",
        description: "Requisição HTTP externa"
      },
      {
        icon: <DataObjectIcon />,
        name: "Variável",
        type: "variable",
        description: "Definir variáveis globais"
      },
    ]
  },
  {
    name: "Agentes de IA",
    color: theme => "#01BBAC",
    icon: <AutoAwesome />,
    nodes: [
      {
        icon: <AutoAwesome />,
        name: "Agente IA – Estratiza AI",
        type: "openai",
        description: "Configure seu agente de IA com todas as informações do seu negócio"
      }
    ]
  }
];

// Função para gerar string aleatória (mantida igual)
function geraStringAleatoria(tamanho) {
  var stringAleatoria = "";
  var caracteres =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < tamanho; i++) {
    stringAleatoria += caracteres.charAt(
      Math.floor(Math.random() * caracteres.length)
    );
  }
  return stringAleatoria;
}

// Tipos de nós (mantido igual)
const nodeTypes = {
  message: messageNode,
  start: startNode,
  //condition: conditionNode,
  menu: menuNode,
  interactiveMenu: interactiveNode,
  interval: intervalNode,
  img: imgNode,
  gemini: geminiNode,
  audio: audioNode,
  randomizer: randomizerNode,
  video: videoNode,
  singleBlock: singleBlockNode,
  ticket: ticketNode,
  tag: tagNode,
  removeTag: removeTagNode,
  addKanban: addKanbanNode,
  removeKanban: removeKanbanNode,
  switchFlow: switchFlowNode,
  attendant: attendantNode,
  httpRequest: HttpRequestNode,
  variable: VariableNode,
  openai: openaiNode,
  input: inputNode,
  conditionCompare: conditionCompareNode,
};

const edgeTypes = {
  buttonedge: RemoveEdge
};

const initialNodes = [
  {
    id: "1",
    position: { x: 250, y: 100 },
    data: { label: "Inicio do fluxo" },
    type: "start"
  }
];

const initialEdges = [];

// Função para detectar se é mobile
const isMobileDevice = () => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) ||
    ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0)
  );
};

// Componente de controles customizados para mobile
const MobileControls = () => {
  const classes = useStyles();
  const { zoomIn, zoomOut, fitView } = useReactFlow();

  return (
    <div className={classes.mobileControls}>
      <IconButton
        onClick={() => zoomIn()}
        className={classes.controlButton}
        size="small"
      >
        <ZoomInIcon />
      </IconButton>

      <IconButton
        onClick={() => zoomOut()}
        className={classes.controlButton}
        size="small"
      >
        <ZoomOutIcon />
      </IconButton>

      <IconButton
        onClick={() => fitView({ padding: 0.2 })}
        className={classes.controlButton}
        size="small"
      >
        <WebAssetIcon />
      </IconButton>
    </div>
  );
};

// Componente de ações rápidas para desktop
const QuickActions = ({ onActionClick }) => {
  const classes = useStyles();

  const quickActions = [
    { icon: <Message />, name: "Texto", type: "text" },
    { icon: <DynamicFeed />, name: "Menu", type: "menu" },
    { icon: <AccessTime />, name: "Intervalo", type: "interval" },
    { icon: <LibraryBooks />, name: "Conteúdo", type: "content" }
  ];

  return (
    <div className={classes.quickActions}>
      {quickActions.map((action) => (
        <Tooltip key={action.type} title={action.name} placement="left">
          <IconButton
            onClick={() => onActionClick(action.type)}
            className={classes.quickActionButton}
            size="medium"
          >
            {action.icon}
          </IconButton>
        </Tooltip>
      ))}
    </div>
  );
};

export const FlowBuilderConfig = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { id } = useParams();

  // Estados para interface
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const [bottomSheetOpen, setBottomSheetOpen] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState(['Básicos']);

  const classes = useStyles({ sidebarOpen });

  // Estados existentes (mantidos)
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [dataNode, setDataNode] = useState(null);
  const [hasMore, setHasMore] = useState(false);

  // Estados dos modais (mantidos)
  const [modalAddText, setModalAddText] = useState(null);
  const [modalAddInterval, setModalAddInterval] = useState(false);
  //const [modalAddCondition, setModalAddCondition] = useState(null);
  const [modalAddMenu, setModalAddMenu] = useState(null);
  const [modalAddInteractive, setModalAddInteractive] = useState(null);
  const [modalAddImg, setModalAddImg] = useState(null);
  const [modalAddAudio, setModalAddAudio] = useState(null);
  const [modalAddRandomizer, setModalAddRandomizer] = useState(null);
  const [modalAddVideo, setModalAddVideo] = useState(null);
  const [modalAddSingleBlock, setModalAddSingleBlock] = useState(null);
  const [modalAddTicket, setModalAddTicket] = useState(null);
  const [modalAddTag, setModalAddTag] = useState(null);
  const [modalAddRemoveTag, setModalAddRemoveTag] = useState(null);
  const [modalAddKanban, setModalAddKanban] = useState(null);
  const [modalRemoveKanban, setModalRemoveKanban] = useState(null);
  const [modalAddSwitchFlow, setModalAddSwitchFlow] = useState(null);
  const [modalAddAttendant, setModalAddAttendant] = useState(null);
  const [modalAddOpenAI, setModalAddOpenAI] = useState(null);
  const [modalAddGemini, setModalAddGemini] = useState(null);
  const [modalAddInput, setModalAddInput] = useState(null);
  //const [modalAddConditionCompare, setModalAddConditionCompare] = useState(null);
  const [modalAddConditionCompare, setModalAddConditionCompare] = useState(null);
  const [modalStartConfig, setModalStartConfig] = useState(false);
  const [startTriggers, setStartTriggers] = useState([]);
  const [startIsCatchAll, setStartIsCatchAll] = useState(false);
  const [startNewPhrase, setStartNewPhrase] = useState("");
  const [startNewType, setStartNewType] = useState("contains");
  const [startScheduleRules, setStartScheduleRules] = useState({ enabled: false, timezone: "America/Sao_Paulo", rules: [], holidays: [] });
  const [flowTitle, setFlowTitle] = useState("");
  const [startScheduleTab, setStartScheduleTab] = useState("triggers");
  const [startWhatsappIds, setStartWhatsappIds] = useState([]);
  const [availableConnections, setAvailableConnections] = useState([]);

  // Estados ReactFlow (mantidos)
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const storageItems = useNodeStorage();

  const connectionLineStyle = {
    stroke: theme.palette.primary.main,
    strokeWidth: isMobileDevice() ? "8px" : "6px"
  };

  // Inicializar sistema de variáveis globais
  useEffect(() => {
    if (!window.flowVariables) {
      window.flowVariables = {};
      console.log("Sistema de variáveis globais inicializado");
    }
    window.getFlowVariable = getFlowVariable;
    window.setFlowVariable = setFlowVariable;
  }, []);

  // Função addNode COMPLETA (mantida igual - muito longa para reproduzir aqui)
  const addNode = (type, data) => {
    const posY = nodes[nodes.length - 1].position.y;
    const posX = nodes[nodes.length - 1].position.x + (nodes[nodes.length - 1].width || 200) + 40;

    if (type === "start") {
      return setNodes(old => {
        return [
          ...old.filter(item => item.id !== "1"),
          {
            id: "1",
            position: { x: posX, y: posY },
            data: { label: "Inicio do fluxo" },
            type: "start"
          }
        ];
      });
    }

    if (type === "text") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { label: data.text },
            type: "message"
          }
        ];
      });
    }

    if (type === "interval") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { label: `Intervalo ${data.sec} seg.`, sec: data.sec },
            type: "interval"
          }
        ];
      });
    }

    if (type === "menu") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              message: data.message,
              arrayOption: data.arrayOption
            },
             type: "menu"
          }
        ];
      });
    }

    if (type === "interactiveMenu") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              message: data.message,
              footer: data.footer,
              headerImage: data.headerImage,
              interactiveType: data.interactiveType,
              listButtonText: data.listButtonText,
              arrayOption: data.arrayOption
            },
            type: "interactiveMenu"
          }
        ];
      });
    }

    if (type === "img") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { url: data.url, caption: data.caption || "" },
            type: "img"
          }
        ];
      });
    }

    if (type === "audio") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { url: data.url, record: data.record, caption: data.caption || "" },
            type: "audio"
          }
        ];
      });
    }

    if (type === "randomizer") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { percent: data.percent },
            type: "randomizer"
          }
        ];
      });
    }

    if (type === "video") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { url: data.url, caption: data.caption || "" },
            type: "video"
          }
        ];
      });
    }

    if (type === "singleBlock") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "singleBlock"
          }
        ];
      });
    }

    if (type === "ticket") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "ticket"
          }
        ];
      });
    }

    if (type === "openai") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "openai",
          },
        ];
      });
    }

    if (type === "gemini") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "gemini",
          },
        ];
      });
    }

    if (type === "tag") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "tag"
          }
        ];
      });
    }

    if (type === "addKanban") {
      return setNodes(old => [
        ...old,
        { id: geraStringAleatoria(30), position: { x: posX, y: posY }, data: { ...data }, type: "addKanban" }
      ]);
    }

    if (type === "removeKanban") {
      return setNodes(old => [
        ...old,
        { id: geraStringAleatoria(30), position: { x: posX, y: posY }, data: { ...data }, type: "removeKanban" }
      ]);
    }

    if (type === "removeTag") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              tag: data?.tag || "",
              ...data,
            },
            type: "removeTag",
          },
        ];
      });
    }

    if (type === "switchFlow") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "switchFlow"
          }
        ];
      });
    }

    if (type === "attendant") {
      return setNodes(old => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: { ...data },
            type: "attendant"
          }
        ]
      })
    }

    if (type === "httpRequest") {
      return setNodes((old) => [
        ...old,
        {
          id: geraStringAleatoria(30),
          position: { x: posX, y: posY },
          data: {
            url: "",
            method: data?.method || "POST",
            requestBody: data?.requestBody || "{}",
            headersString: data?.headersString || "",
            queryParams: data?.queryParams || [],
            saveVariables: data?.saveVariables || [],
            ...data,
          },
          type: "httpRequest",
        },
      ]);
    }

    if (type === "variable") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              variableName: data?.variableName || "",
              variableValue: data?.variableValue || "",
              variableType: data?.variableType || "text",
              variableExpression: data?.variableExpression || "",
              isExpression: data?.isExpression || false,
              ...data,
            },
            type: "variable",
          },
        ];
      });
    }

    if (type === "input") {
      return setNodes((old) => {
        return [
          ...old,
          {
            id: geraStringAleatoria(30),
            position: { x: posX, y: posY },
            data: {
              question: data?.question || "",
              variableName: data?.variableName || "",
              ...data,
            },
              type: "input",
          },
        ];
      });
    }

    if (type === "conditionCompare") {
      return setNodes((old) => [
        ...old,
        {
          id: geraStringAleatoria(30),
          position: { x: posX, y: posY },
          data: {
            leftValue: data?.leftValue || "",
            operator: data?.operator || "equals",
            rightValue: data?.rightValue || "",
            ...data,
          },
          type: "conditionCompare",
        },
      ]);
    }
  };

  // Funções de adição (mantidas)
  const textAdd = data => addNode("text", data);
  const intervalAdd = data => addNode("interval", data);
  //const conditionAdd = data => addNode("condition", data);
  const menuAdd = data => addNode("menu", data);
  const interactiveMenuAdd = data => addNode("interactiveMenu", data);
  const imgAdd = data => addNode("img", data);
  const audioAdd = data => addNode("audio", data);
  const randomizerAdd = data => addNode("randomizer", data);
  const videoAdd = data => addNode("video", data);
  const singleBlockAdd = data => addNode("singleBlock", data);
  const ticketAdd = data => addNode("ticket", data);
  const tagAdd = data => addNode("tag", data);
  const openaiAdd = data => addNode("openai", data);
  const geminiAdd = data => addNode("gemini", data);
  const removeTagAdd = data => addNode("removeTag", data);
  const addKanbanAdd = data => addNode("addKanban", data);
  const removeKanbanAdd = data => addNode("removeKanban", data);
  const switchFlowAdd = data => addNode("switchFlow", data);
  const attendantAdd = data => addNode("attendant", data);
  const variableAdd = data => addNode("variable", data);
  const inputAdd = data => addNode("input", data);
  const conditionCompareAdd = data => addNode("conditionCompare", data);

  // useEffect para carregar fluxo COMPLETO (mantido)
  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get(`/flowbuilder/flow/${id}`);
          setFlowTitle(data.flow.name || "");
          if (data.flow.flow !== null) {
            const preparedNodes = data.flow.flow.nodes.map((node) => {
              // Inject trigger/schedule data from FlowBuilder model into start node
              if (node.type === "start") {
                node.data = {
                  ...node.data,
                  triggers: (data.flow.triggers || []).map(t => ({ text: t, type: "contains" })),
                  isCatchAll: data.flow.isCatchAll || false,
                  scheduleRules: data.flow.scheduleRules || { enabled: false, timezone: "America/Sao_Paulo", rules: [], holidays: [] },
                  whatsappIds: data.flow.whatsappIds || [],
                };
              }
              if (node.type === "httpRequest") {
                console.log(`[FlowBuilder] Processando nó HTTP Request: ${node.id}`);

                if (node.data.saveVariables && node.data.saveVariables.length > 0) {
                  console.log(
                    `[FlowBuilder] Nó ${node.id} tem ${node.data.saveVariables.length} variáveis configuradas`
                  );

                  if (
                    !node.data.responseVariables ||
                    !Array.isArray(node.data.responseVariables)
                  ) {
                    console.log(
                      `[FlowBuilder] Configurando responseVariables para nó ${node.id}`
                    );
                    node.data.responseVariables = node.data.saveVariables.map(
                      (item) => ({
                        path: item.path,
                        variableName: item.variable,
                      })
                    );
                  }
                } else {
                  node.data.saveVariables = node.data.saveVariables || [];
                  node.data.responseVariables = node.data.responseVariables || [];
                }

                console.log(`[FlowBuilder] Nó HTTP Request ${node.id} processado:`, {
                  url: node.data.url,
                  method: node.data.method,
                  saveVariables: node.data.saveVariables?.length || 0,
                  responseVariables: node.data.responseVariables?.length || 0,
                });
              }
              return node;
            });

            setNodes(preparedNodes);
            setEdges(data.flow.flow.connections);
          }
          setLoading(false);
        } catch (err) {
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [id]);

  // useEffect para storage COMPLETO (mantido)
  useEffect(() => {
    if (storageItems.action === "delete") {
      setNodes(old => old.filter(item => item.id !== storageItems.node));
      setEdges(old => {
        const newData = old.filter(item => item.source !== storageItems.node);
        const newClearTarget = newData.filter(
          item => item.target !== storageItems.node
        );
        return newClearTarget;
      });
      storageItems.setNodesStorage("");
      storageItems.setAct("idle");
    }
    if (storageItems.action === "disconnect") {
      setEdges(old => old.filter(
        item => item.source !== storageItems.node && item.target !== storageItems.node
      ));
      storageItems.setNodesStorage("");
      storageItems.setAct("idle");
    }
    if (storageItems.action === "duplicate") {
      const nodeDuplicate = nodes.filter(
        item => item.id === storageItems.node
      )[0];
      const maioresX = nodes.map(node => node.position.x);
      const maiorX = Math.max(...maioresX);
      const finalY = nodes[nodes.length - 1].position.y;
      const nodeNew = {
        ...nodeDuplicate,
        id: geraStringAleatoria(30),
        position: {
          x: maiorX + 240,
          y: finalY
        },
        selected: false,
        style: {
          backgroundColor: theme.palette.grey[800],
          padding: 0,
          borderRadius: 8,
          border: `1px solid ${theme.palette.divider}`
        }
      };
      setNodes(old => [...old, nodeNew]);
      storageItems.setNodesStorage("");
      storageItems.setAct("idle");
    }
  }, [storageItems.action, nodes, theme]);

  const onConnect = useCallback(
    params => setEdges(eds => addEdge(params, eds)),
    [setEdges]
  );

  // Função de salvar COMPLETA (mantida)
  const saveFlow = async () => {
    try {
      console.log("[FlowBuilder] Preparando para salvar fluxo...");
      const processedNodes = nodes.map((node) => {
        if (node.type === "httpRequest") {
          console.log(`[FlowBuilder] Processando nó HTTP Request: ${node.id}`);
          if (node.data.saveVariables && node.data.saveVariables.length > 0) {
            console.log(
              `[FlowBuilder] Nó ${node.id} tem ${node.data.saveVariables.length} variáveis configuradas`
            );

            if (
              !node.data.responseVariables ||
              !Array.isArray(node.data.responseVariables)
            ) {
              console.log(
                `[FlowBuilder] Configurando responseVariables para nó ${node.id}`
              );
              node.data.responseVariables = node.data.saveVariables.map(
                (item) => ({
                  path: item.path,
                  variableName: item.variable,
                })
              );
            }
          } else {
            node.data.saveVariables = node.data.saveVariables || [];
            node.data.responseVariables = node.data.responseVariables || [];
          }

          console.log(`[FlowBuilder] Nó HTTP Request ${node.id} processado:`, {
            url: node.data.url,
            method: node.data.method,
            saveVariables: node.data.saveVariables?.length || 0,
            responseVariables: node.data.responseVariables?.length || 0,
          });
        }
        return node;
      });

      console.log("[FlowBuilder] Enviando fluxo para o servidor...");

      await api
        .post("/flowbuilder/flow", {
          idFlow: id,
          nodes: processedNodes,
          connections: edges,
        })
        .then((res) => {
          toast.success("Fluxo salvo com sucesso");
          setNodes(processedNodes);
        });
    } catch (error) {
      toast.error("Erro ao salvar o fluxo");
      console.error("Erro ao salvar o fluxo:", error);
    }
  };

  // Event handlers COMPLETOS (mantidos mas adaptados para tema)
  const doubleClick = (event, node) => {
    setDataNode(node);
    if (node.type === "message") setModalAddText("edit");
    if (node.type === "interval") setModalAddInterval("edit");
    if (node.type === "menu") setModalAddMenu("edit");
    if (node.type === "img") setModalAddImg("edit");
    if (node.type === "audio") setModalAddAudio("edit");
    if (node.type === "randomizer") setModalAddRandomizer("edit");
    if (node.type === "video") setModalAddVideo("edit");
    if (node.type === "singleBlock") setModalAddSingleBlock("edit");
    if (node.type === "ticket") setModalAddTicket("edit");
    if (node.type === "tag") setModalAddTag("edit");
    if (node.type === "removeTag") setModalAddRemoveTag("edit");
    if (node.type === "addKanban") setModalAddKanban("edit");
    if (node.type === "removeKanban") setModalRemoveKanban("edit");
    if (node.type === "switchFlow") setModalAddSwitchFlow("edit");
    if (node.type === "openai") setModalAddOpenAI("edit");
    if (node.type === "gemini") setModalAddGemini("edit");
    if (node.type === "interactiveMenu") setModalAddInteractive("edit");
    if (node.type === "attendant") setModalAddAttendant("edit");
    if (node.type === "httpRequest") {
      if (node.data.saveVariables && node.data.saveVariables.length > 0) {
        if (
          !node.data.responseVariables ||
          !Array.isArray(node.data.responseVariables)
        ) {
          node.data.responseVariables = node.data.saveVariables.map((item) => ({
            path: item.path,
            variableName: item.variable,
          }));

          setNodes((old) =>
            old.map((itemNode) => {
              if (itemNode.id === node.id) {
                return node;
              }
              return itemNode;
            })
          );

          console.log("[FlowBuilder] Nó HTTP Request atualizado:", node.id);
        }
      }
    }
    if (node.type === "input") setModalAddInput("edit");
    if (node.type === "conditionCompare") setModalAddConditionCompare("edit");
    if (node.type === "start") {
      const t = node.data?.triggers || [];
      setStartTriggers(Array.isArray(t) ? t : []);
      setStartIsCatchAll(node.data?.isCatchAll || false);
      setStartScheduleRules(node.data?.scheduleRules || { enabled: false, timezone: "America/Sao_Paulo", rules: [], holidays: [] });
      setStartNewPhrase("");
      setStartScheduleTab("triggers");
      setStartWhatsappIds(node.data?.whatsappIds || []);
      // Carregar conexoes disponiveis
      api.get("/whatsapp/").then(({ data: wdata }) => {
        const conns = Array.isArray(wdata) ? wdata : (wdata?.whatsapps || []);
        setAvailableConnections(conns.filter(w => w.status === "CONNECTED" || w.status === "qrcode"));
      }).catch(() => {});
      setModalStartConfig(true);
    }
  };

  const handleSaveStartConfig = async () => {
    try {
      // Update node in canvas
      setNodes(old => old.map(n => {
        if (n.type === "start") {
          return {
            ...n,
            data: {
              ...n.data,
              triggers: startIsCatchAll ? [] : startTriggers,
              isCatchAll: startIsCatchAll,
              scheduleRules: startScheduleRules,
              whatsappIds: startWhatsappIds,
            }
          };
        }
        return n;
      }));
      // Persist to backend
      await api.put(`/flowbuilder/${id}/triggers`, {
        triggers: startIsCatchAll ? [] : startTriggers.map(t => t.text),
        isCatchAll: startIsCatchAll,
        scheduleRules: startScheduleRules,
      });
      await api.put(`/flowbuilder/${id}/connections`, { whatsappIds: startWhatsappIds });
      setModalStartConfig(false);
      toast.success("Gatilho salvo!");
    } catch (err) {
      toast.error("Erro ao salvar gatilho");
    }
  };

  const clickNode = (event, node) => {
    setNodes(old =>
      old.map(item => {
        if (item.id === node.id) {
          return {
            ...item,
            style: {
              backgroundColor: theme.palette.primary.main,
              padding: 1,
              borderRadius: 8,
              border: `2px solid ${theme.palette.primary.dark}`
            }
          };
        }
        return {
          ...item,
          style: {
            backgroundColor: theme.palette.grey[800],
            padding: 0,
            borderRadius: 8,
            border: `1px solid ${theme.palette.divider}`
          }
        };
      })
    );
  };

  const clickEdge = (event, node) => {
    setNodes(old =>
      old.map(item => {
        return {
          ...item,
          style: {
            backgroundColor: theme.palette.grey[800],
            padding: 0,
            borderRadius: 8,
            border: `1px solid ${theme.palette.divider}`
          }
        };
      })
    );
  };

  const doubleClickEdge = useCallback((event, edge) => {
    event.stopPropagation();
    setEdges(eds => eds.filter(e => e.id !== edge.id));
  }, [setEdges]);

  const updateNode = dataAlter => {
    setNodes(old =>
      old.map(itemNode => {
        if (itemNode.id === dataAlter.id) {
          return dataAlter;
        }
        return itemNode;
      })
    );
    // Fechar todos os modais
    setModalAddText(null);
    setModalAddInterval(null);
    setModalAddMenu(null);
    setModalAddInteractive(null);
    setModalAddImg(null);
    setModalAddOpenAI(null);
    setModalAddAudio(null);
    setModalAddRandomizer(null);
    setModalAddVideo(null);
    setModalAddGemini(null);
    setModalAddSingleBlock(null);
    setModalAddTicket(null);
    setModalAddRemoveTag(null);
    setModalAddTag(null);
    setModalAddKanban(null);
    setModalRemoveKanban(null);
    setModalAddSwitchFlow(null);
    setModalAddAttendant(null);
    setModalAddInput(null);
    setModalAddConditionCompare(null);
  };

  // Handler para categoria expand/collapse
  const handleCategoryToggle = (categoryName) => {
    setExpandedCategories(prev =>
      prev.includes(categoryName)
        ? prev.filter(name => name !== categoryName)
        : [...prev, categoryName]
    );
  };

  // Handler para ações de nós
  const clickActions = type => {
    setBottomSheetOpen(false);

    switch (type) {
      case "start":
        addNode("start");
        break;
      case "menu":
        setModalAddMenu("create");
        break;
      case "content":
        setModalAddSingleBlock("create");
        break;
      case "interactiveMenu":
        setModalAddInteractive("create");
        break;
      case "text":
        setModalAddText("create");
        break;
      case "random":
        setModalAddRandomizer("create");
        break;
      case "interval":
        setModalAddInterval("create");
        break;
      case "ticket":
        setModalAddTicket("create");
        break;
      case "tag":
        setModalAddTag("create");
        break;
      case "removeTag":
        setModalAddRemoveTag("create");
        break;
      case "addKanban":
        setModalAddKanban("create");
        break;
      case "removeKanban":
        setModalRemoveKanban("create");
        break;
      case "switchFlow":
        setModalAddSwitchFlow("create");
        break;
      case "attendant":
        setModalAddAttendant("create");
        break;
      case "httpRequest":
        addNode("httpRequest");
        break;
      case "variable":
        addNode("variable");
        break;
      case "input":
        setModalAddInput("create");
        break;
      case "conditionCompare":
        setModalAddConditionCompare("create");
        break;
      case "openai":
        setModalAddOpenAI("create");
        break;
      case "gemini":
        setModalAddGemini("create");
        break;
      case "img":
        setModalAddImg("create");
        break;
      case "audio":
        setModalAddAudio("create");
        break;
      case "video":
        setModalAddVideo("create");
        break;
      default:
    }
  };

  // Componente do Sidebar
  const SidebarContent = () => (
    <div className={classes.sidebarContent}>
      {nodeCategories.map((category) => (
        <div key={category.name}>
          {sidebarOpen ? (
            // Modo expandido
            <>
              <div className={classes.categoryHeader}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  onClick={() => handleCategoryToggle(category.name)}
                  style={{ cursor: "pointer" }}
                >
                  <Box display="flex" alignItems="center" gap={1}>
                    <Box sx={{ color: typeof category.color === 'function' ? category.color(theme) : category.color }}>
                      {category.icon}
                    </Box>
                    <Typography variant="body2">
                      {category.name}
                    </Typography>
                  </Box>
                  {expandedCategories.includes(category.name) ? <ExpandLess /> : <ExpandMore />}
                </Box>
              </div>

              <Collapse in={expandedCategories.includes(category.name)}>
                <List dense>
                  {category.nodes.map((node) => (
                    <ListItem key={node.type} disablePadding>
                      <Button
                        fullWidth
                        variant="text"
                        className={classes.nodeButton}
                        onClick={() => clickActions(node.type)}
                        startIcon={
                          <Box sx={{ color: typeof category.color === 'function' ? category.color(theme) : category.color }}>
                            {node.icon}
                          </Box>
                        }
                      >
                        <Box textAlign="left" width="100%">
                          <Typography variant="body2">
                            {node.name}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            {node.description}
                          </Typography>
                        </Box>
                      </Button>
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            </>
          ) : (
            // Modo colapsado - só ícones
            <div>
              {category.nodes.map((node) => (
                <Tooltip key={node.type} title={node.name} placement="right">
                  <IconButton
                    className={classes.collapsedNodeButton}
                    onClick={() => clickActions(node.type)}
                    style={{ color: typeof category.color === 'function' ? category.color(theme) : category.color }}
                  >
                    {node.icon}
                  </IconButton>
                </Tooltip>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );

  // Componente do Bottom Sheet
  const BottomSheetContent = () => (
    <Slide direction="up" in={bottomSheetOpen} mountOnEnter unmountOnExit>
      <div className={classes.bottomSheet}>
        <div
          className={classes.bottomSheetHandle}
          onClick={() => setBottomSheetOpen(false)}
        />

        <div className={classes.bottomSheetHeader}>
          <Typography variant="h6">Adicionar Nós</Typography>
          <IconButton onClick={() => setBottomSheetOpen(false)} size="small">
            <CloseIcon />
          </IconButton>
        </div>

        <div className={classes.bottomSheetContent}>
          <Grid container spacing={2}>
            {nodeCategories.map((category) => (
              <Grid item xs={6} key={category.name}>
                <Paper elevation={1} className={classes.categoryCard} style={{ padding: 8 }}>
                  <Typography
                    variant="subtitle2"
                    className={classes.categoryTitle}
                    style={{ color: typeof category.color === 'function' ? category.color(theme) : category.color, marginBottom: 8 }}
                  >
                    {category.name}
                  </Typography>
                  {category.nodes.map((node) => (
                    <Button
                      key={node.type}
                      fullWidth
                      variant="outlined"
                      onClick={() => clickActions(node.type)}
                      startIcon={
                        <Box sx={{ color: typeof category.color === 'function' ? category.color(theme) : category.color }}>
                          {node.icon}
                        </Box>
                      }
                      className={classes.categoryNodeBtn}
                      size="small"
                    >
                      {node.name}
                    </Button>
                  ))}
                </Paper>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </Slide>
  );

  if (loading) {
    return (
      <div className={classes.root}>
        <div className={classes.header}>
          <MainHeader>
            <Title>Editor de Fluxos</Title>
          </MainHeader>
        </div>
        <div className={classes.loadingContainer}>
          <CircularProgress style={{ color: theme.palette.primary.main }} />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      {/* Header */}
      <div className={classes.header}>
        <MainHeader>
          <Title>{flowTitle ? flowTitle : "Editor de Fluxos"}</Title>
        </MainHeader>
      </div>

      {/* Content */}
      <div className={classes.content}>
        {/* Sidebar Desktop */}
        {!isMobile && (
          <div className={classes.sidebar}>
            <div className={classes.sidebarHeader}>
              {sidebarOpen && (
                <Typography variant="subtitle1" fontWeight="bold">
                  Biblioteca de blocos
                </Typography>
              )}
              <IconButton
                onClick={() => setSidebarOpen(!sidebarOpen)}
                size="small"
              >
                {sidebarOpen ? <ChevronLeft /> : <ChevronRight />}
              </IconButton>
            </div>
            <SidebarContent />
          </div>
        )}

        {/* Flow Container */}
        <div className={classes.flowContainer}>
          <div className={classes.canvasLegend}>
            <span className={classes.canvasLegendBadge}>EDITOR</span>
            <span className={classes.canvasLegendText}>Arraste, conecte e configure os blocos da jornada</span>
          </div>
          <ReactFlow
            nodes={nodes}
            edges={edges}
            deleteKeyCode={["Backspace", "Delete"]}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onNodeDoubleClick={doubleClick}
            onNodeClick={clickNode}
            onEdgeClick={clickEdge}
            onEdgeDoubleClick={doubleClickEdge}
            onConnect={onConnect}
            nodeTypes={nodeTypes}
            fitView
            connectionLineStyle={connectionLineStyle}
            style={{
              backgroundColor: "transparent"
            }}
            edgeTypes={edgeTypes}
            variant={"cross"}
            defaultEdgeOptions={{
              style: { color: "#ff0000", strokeWidth: "6px" },
              animated: false
            }}
          >
            <Controls />
            <MiniMap />
            <Background variant="dots" gap={12} size={1} color="#B9D4C4" />
          </ReactFlow>

        </div>
      </div>

      {/* Mobile Controls */}
      {isMobile && <MobileControls />}

      {/* Botão Salvar - agora posicionado acima dos quickActions */}
      <Fab
        color="primary"
        className={classes.fab}
        onClick={saveFlow}
        title="Salvar Fluxo"
      >
        <SaveIcon />
      </Fab>

      {/* Quick Actions Desktop - agora abaixo do botão salvar */}
      {!isMobile && <QuickActions onActionClick={clickActions} />}

      {/* Bottom Sheet Mobile */}
      {isMobile && <BottomSheetContent />}

      {/* FAB Adicionar - só em mobile */}
      {isMobile && (
        <Fab
          color="secondary"
          className={classes.addFab}
          onClick={() => setBottomSheetOpen(true)}
        >
          <AddIcon />
        </Fab>
      )}

      {/* Click Away Listener para Bottom Sheet */}
      {isMobile && bottomSheetOpen && (
        <ClickAwayListener onClickAway={() => setBottomSheetOpen(false)}>
          <div />
        </ClickAwayListener>
      )}

      {/* Start Node Config Modal */}
      {modalStartConfig && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(0,0,0,0.55)", zIndex: 9999,
          display: "flex", alignItems: "center", justifyContent: "center",
        }} onClick={() => setModalStartConfig(false)}>
          <div style={{
            background: "#fff", borderRadius: 14, padding: 0, minWidth: 440, maxWidth: 560,
            boxShadow: "0 20px 60px rgba(0,0,0,0.3)", overflow: "hidden",
          }} onClick={e => e.stopPropagation()}>

            {/* Header */}
            <div style={{ background: "linear-gradient(135deg,#6366F1,#8B5CF6)", padding: "18px 24px" }}>
              <div style={{ color: "#fff", fontWeight: 700, fontSize: 17 }}>⚡ Configurar Início do Fluxo</div>
              <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 12, marginTop: 2 }}>
                Defina quando este fluxo será ativado
              </div>
            </div>

            {/* Tabs */}
            <div style={{ display: "flex", borderBottom: "1px solid #eee" }}>
              {["triggers", "schedule"].map(tab => (
                <button key={tab} onClick={() => setStartScheduleTab(tab)} style={{
                  flex: 1, padding: "11px 0", border: "none", cursor: "pointer",
                  background: startScheduleTab === tab ? "#fff" : "#f8f8f8",
                  fontWeight: startScheduleTab === tab ? 700 : 400,
                  color: startScheduleTab === tab ? "#6366F1" : "#888",
                  fontSize: 13,
                  borderBottom: startScheduleTab === tab ? "2.5px solid #6366F1" : "2.5px solid transparent",
                  transition: "all 0.15s",
                }}>
                  {tab === "triggers" ? "🎯 Gatilhos" : "🕐 Horário"}
                </button>
              ))}
            </div>

            <div style={{ padding: "20px 24px" }}>

              {/* TAB: GATILHOS */}
              {startScheduleTab === "triggers" && (
                <div>
                  <div style={{
                    background: "rgba(99,102,241,0.07)", borderRadius: 8,
                    padding: "8px 12px", fontSize: 12, color: "#4338CA", marginBottom: 16,
                  }}>
                    Frases específicas têm prioridade sobre o Fluxo Padrão. Contém = a mensagem inclui a palavra. Igual = mensagem exata.
                  </div>

                  {/* Catch-all toggle */}
                  <label style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16, cursor: "pointer" }}>
                    <div
                      onClick={() => { setStartIsCatchAll(!startIsCatchAll); setStartTriggers([]); }}
                      style={{
                        width: 44, height: 24, borderRadius: 12,
                        background: startIsCatchAll ? "#6366F1" : "#ddd",
                        position: "relative", transition: "background 0.2s", flexShrink: 0,
                      }}
                    >
                      <div style={{
                        width: 18, height: 18, borderRadius: 9, background: "#fff",
                        position: "absolute", top: 3,
                        left: startIsCatchAll ? 22 : 4,
                        transition: "left 0.2s",
                      }} />
                    </div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14 }}>Fluxo Padrão</div>
                      <div style={{ fontSize: 11, color: "#888" }}>Ativa quando nenhum outro fluxo for reconhecido</div>
                    </div>
                  </label>

                  {!startIsCatchAll && (
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8 }}>Frases que ativam este fluxo:</div>

                      {startTriggers.map((t, i) => (
                        <div key={i} style={{
                          display: "flex", alignItems: "center", gap: 8,
                          background: "#f8f8f8", borderRadius: 8, padding: "6px 10px", marginBottom: 6,
                        }}>
                          <span style={{
                            fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4,
                            background: t.type === "exact" ? "rgba(239,68,68,0.1)" : "rgba(0,201,122,0.1)",
                            color: t.type === "exact" ? "#DC2626" : "#00875A",
                          }}>{t.type === "exact" ? "IGUAL" : "CONTÉM"}</span>
                          <span style={{ flex: 1, fontStyle: "italic", fontSize: 13 }}>"{t.text}"</span>
                          <button
                            onClick={() => setStartTriggers(old => old.filter((_, idx) => idx !== i))}
                            style={{ background: "none", border: "none", cursor: "pointer", color: "#EF4444", fontSize: 18, padding: 0, lineHeight: 1 }}
                          >×</button>
                        </div>
                      ))}

                      <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
                        <input
                          value={startNewPhrase}
                          onChange={e => setStartNewPhrase(e.target.value)}
                          onKeyDown={e => {
                            if (e.key === "Enter" && startNewPhrase.trim()) {
                              setStartTriggers(old => [...old, { text: startNewPhrase.trim(), type: startNewType }]);
                              setStartNewPhrase("");
                            }
                          }}
                          placeholder="Digite uma frase..."
                          style={{
                            flex: 1, border: "1.5px solid #e0e0e0", borderRadius: 8,
                            padding: "8px 12px", fontSize: 13, outline: "none",
                          }}
                        />
                        <select
                          value={startNewType}
                          onChange={e => setStartNewType(e.target.value)}
                          style={{ border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "8px", fontSize: 12, outline: "none" }}
                        >
                          <option value="contains">Contém</option>
                          <option value="exact">Igual</option>
                        </select>
                        <button
                          onClick={() => {
                            if (startNewPhrase.trim()) {
                              setStartTriggers(old => [...old, { text: startNewPhrase.trim(), type: startNewType }]);
                              setStartNewPhrase("");
                            }
                          }}
                          style={{
                            background: "#6366F1", color: "#fff", border: "none",
                            borderRadius: 8, padding: "8px 14px", cursor: "pointer", fontWeight: 700, fontSize: 18,
                          }}
                        >+</button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Selecao de conexoes */}
              {startScheduleTab === "triggers" && availableConnections.length > 0 && (
                <div style={{ marginTop: 16, borderTop: "1px solid #eee", paddingTop: 14 }}>
                  <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 6, color: "#333" }}>Conexoes que ativam este fluxo:</div>
                  <div style={{ fontSize: 11, color: "#888", marginBottom: 10 }}>Deixe em branco para ativar em todas as conexoes.</div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    {availableConnections.map(conn => (
                      <label key={conn.id} style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", padding: "6px 10px", borderRadius: 7, background: startWhatsappIds.includes(conn.id) ? "rgba(99,102,241,0.08)" : "#fafafa", border: "1px solid " + (startWhatsappIds.includes(conn.id) ? "rgba(99,102,241,0.4)" : "#eee") }}>
                        <input type="checkbox" checked={startWhatsappIds.includes(conn.id)}
                          onChange={e => {
                            if (e.target.checked) setStartWhatsappIds(prev => [...prev, conn.id]);
                            else setStartWhatsappIds(prev => prev.filter(x => x !== conn.id));
                          }}
                          style={{ accentColor: "#6366F1", width: 16, height: 16 }} />
                        <span style={{ fontSize: 13, fontWeight: 500 }}>{conn.name}</span>
                        <span style={{ fontSize: 11, color: conn.status === "CONNECTED" ? "#00875A" : "#888", marginLeft: "auto" }}>{conn.status === "CONNECTED" ? "Conectada" : conn.status}</span>
                      </label>
                    ))}
                  </div>
                </div>
              )}

              {/* TAB: HORÁRIO */}
              {startScheduleTab === "schedule" && (
                <div>
                  <label style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16, cursor: "pointer" }}>
                    <div
                      onClick={() => setStartScheduleRules(old => ({ ...old, enabled: !old.enabled }))}
                      style={{
                        width: 44, height: 24, borderRadius: 12,
                        background: startScheduleRules.enabled ? "#6366F1" : "#ddd",
                        position: "relative", transition: "background 0.2s", flexShrink: 0,
                      }}
                    >
                      <div style={{
                        width: 18, height: 18, borderRadius: 9, background: "#fff",
                        position: "absolute", top: 3,
                        left: startScheduleRules.enabled ? 22 : 4,
                        transition: "left 0.2s",
                      }} />
                    </div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14 }}>Ativar restrição de horário</div>
                      <div style={{ fontSize: 11, color: "#888" }}>O fluxo só funcionará nos horários abaixo</div>
                    </div>
                  </label>

                  {startScheduleRules.enabled && (
                    <div>
                      {/* Timezone */}
                      <div style={{ marginBottom: 14 }}>
                        <div style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 6 }}>Fuso horário</div>
                        <select
                          value={startScheduleRules.timezone}
                          onChange={e => setStartScheduleRules(old => ({ ...old, timezone: e.target.value }))}
                          style={{ width: "100%", border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "8px 10px", fontSize: 13, outline: "none" }}
                        >
                          <option value="America/Sao_Paulo">América/São Paulo (BRT -3)</option>
                          <option value="America/Manaus">América/Manaus (AMT -4)</option>
                          <option value="America/Belem">América/Belém (BRT -3)</option>
                          <option value="America/Fortaleza">América/Fortaleza (BRT -3)</option>
                          <option value="America/Recife">América/Recife (BRT -3)</option>
                          <option value="America/Bahia">América/Bahia (BRT -3)</option>
                          <option value="America/Porto_Velho">América/Porto Velho (AMT -4)</option>
                          <option value="America/Boa_Vista">América/Boa Vista (AMT -4)</option>
                          <option value="America/Rio_Branco">América/Rio Branco (ACT -5)</option>
                          <option value="America/Noronha">América/Noronha (FNT -2)</option>
                        </select>
                      </div>

                      {/* Time rules */}
                      <div style={{ marginBottom: 14 }}>
                        <div style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 8 }}>Dias e horários ativos</div>
                        {(startScheduleRules.rules || []).map((rule, ri) => (
                          <div key={ri} style={{ background: "#f8f8f8", borderRadius: 8, padding: "10px 12px", marginBottom: 8 }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                              <span style={{ fontSize: 12, fontWeight: 600, color: "#444" }}>Regra {ri + 1}</span>
                              <button onClick={() => setStartScheduleRules(old => ({ ...old, rules: old.rules.filter((_, i) => i !== ri) }))}
                                style={{ background: "none", border: "none", cursor: "pointer", color: "#EF4444", fontSize: 16, padding: 0 }}>×</button>
                            </div>
                            <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginBottom: 8 }}>
                              {["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"].map((d, di) => (
                                <button key={di} onClick={() => {
                                  setStartScheduleRules(old => ({
                                    ...old,
                                    rules: old.rules.map((r, i) => i === ri ? {
                                      ...r,
                                      days: r.days.includes(di) ? r.days.filter(x => x !== di) : [...r.days, di]
                                    } : r)
                                  }));
                                }} style={{
                                  padding: "3px 8px", borderRadius: 6, border: "1.5px solid",
                                  borderColor: rule.days.includes(di) ? "#6366F1" : "#ddd",
                                  background: rule.days.includes(di) ? "rgba(99,102,241,0.1)" : "#fff",
                                  color: rule.days.includes(di) ? "#6366F1" : "#999",
                                  fontSize: 11, fontWeight: rule.days.includes(di) ? 700 : 400,
                                  cursor: "pointer",
                                }}>{d}</button>
                              ))}
                            </div>
                            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                              <input type="time" value={rule.startTime}
                                onChange={e => setStartScheduleRules(old => ({ ...old, rules: old.rules.map((r, i) => i === ri ? { ...r, startTime: e.target.value } : r) }))}
                                style={{ border: "1.5px solid #e0e0e0", borderRadius: 6, padding: "5px 8px", fontSize: 13, outline: "none" }} />
                              <span style={{ color: "#888", fontSize: 12 }}>até</span>
                              <input type="time" value={rule.endTime}
                                onChange={e => setStartScheduleRules(old => ({ ...old, rules: old.rules.map((r, i) => i === ri ? { ...r, endTime: e.target.value } : r) }))}
                                style={{ border: "1.5px solid #e0e0e0", borderRadius: 6, padding: "5px 8px", fontSize: 13, outline: "none" }} />
                            </div>
                          </div>
                        ))}
                        <button onClick={() => setStartScheduleRules(old => ({
                          ...old,
                          rules: [...(old.rules || []), { id: Date.now().toString(), days: [1,2,3,4,5], startTime: "08:00", endTime: "18:00" }]
                        }))} style={{
                          width: "100%", border: "1.5px dashed #6366F1", background: "rgba(99,102,241,0.04)",
                          borderRadius: 8, padding: "8px", cursor: "pointer", color: "#6366F1", fontSize: 13, fontWeight: 600,
                        }}>+ Adicionar regra de horário</button>
                      </div>

                      {/* Feriados */}
                      <div>
                        <div style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 6 }}>Feriados (o fluxo NÃO ativa nestas datas)</div>
                        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 6 }}>
                          {(startScheduleRules.holidays || []).map((h, hi) => (
                            <span key={hi} style={{
                              background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.2)",
                              color: "#DC2626", borderRadius: 6, padding: "3px 8px", fontSize: 12,
                              display: "flex", alignItems: "center", gap: 4,
                            }}>
                              {h}
                              <button onClick={() => setStartScheduleRules(old => ({ ...old, holidays: old.holidays.filter((_, i) => i !== hi) }))}
                                style={{ background: "none", border: "none", cursor: "pointer", color: "#DC2626", fontSize: 14, padding: 0, lineHeight: 1 }}>×</button>
                            </span>
                          ))}
                        </div>
                        <input type="date"
                          onChange={e => {
                            if (e.target.value && !(startScheduleRules.holidays || []).includes(e.target.value)) {
                              setStartScheduleRules(old => ({ ...old, holidays: [...(old.holidays || []), e.target.value] }));
                              e.target.value = "";
                            }
                          }}
                          style={{ border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "7px 10px", fontSize: 13, outline: "none" }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}

            </div>

            {/* Footer buttons */}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, padding: "14px 24px", borderTop: "1px solid #f0f0f0" }}>
              <button
                onClick={() => setModalStartConfig(false)}
                style={{ padding: "9px 18px", borderRadius: 8, border: "1.5px solid #e0e0e0", background: "#fff", cursor: "pointer", fontSize: 13 }}
              >Cancelar</button>
              <button
                onClick={handleSaveStartConfig}
                style={{ padding: "9px 22px", borderRadius: 8, border: "none", background: "linear-gradient(135deg,#6366F1,#8B5CF6)", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 13 }}
              >Salvar</button>
            </div>
          </div>
        </div>
      )}

      {/* TODOS OS MODAIS COMPLETOS - mantidos iguais */}
      <FlowBuilderAddTextModal
        open={modalAddText}
        onSave={textAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddText}
      />
      <FlowBuilderIntervalModal
        open={modalAddInterval}
        onSave={intervalAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddInterval}
      />
      <FlowBuilderMenuModal
        open={modalAddMenu}
        onSave={menuAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddMenu}
      />
      <FlowBuilderInteractiveModal
        open={modalAddInteractive}
        onSave={interactiveMenuAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddInteractive}
      />
      <FlowBuilderAddImgModal
        open={modalAddImg}
        onSave={imgAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddImg}
      />
      <FlowBuilderAddAudioModal
        open={modalAddAudio}
        onSave={audioAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddAudio}
      />
      <FlowBuilderRandomizerModal
        open={modalAddRandomizer}
        onSave={randomizerAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddRandomizer}
      />
      <FlowBuilderAddVideoModal
        open={modalAddVideo}
        onSave={videoAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddVideo}
      />
      <FlowBuilderSingleBlockModal
        open={modalAddSingleBlock}
        onSave={singleBlockAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddSingleBlock}
      />
      <FlowBuilderTicketModal
        open={modalAddTicket}
        onSave={ticketAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddTicket}
      />
      <FlowBuilderOpenAIModal
        open={modalAddOpenAI}
        onSave={openaiAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddOpenAI}
      />
      <FlowBuilderGeminiModal
        open={modalAddGemini}
        onSave={geminiAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddGemini}
      />
      <FlowBuilderAddTagModal
        open={modalAddTag}
        onSave={tagAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddTag}
      />
      <FlowBuilderRemoveTagModal
        open={modalAddRemoveTag}
        onSave={removeTagAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={() => setModalAddRemoveTag(null)}
      />
      <FlowBuilderAddSwitchFlowModal
        open={modalAddSwitchFlow}
        onSave={switchFlowAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddSwitchFlow}
      />
      <FlowBuilderAddAttendantModal
        open={modalAddAttendant}
        onSave={attendantAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddAttendant}
      />
      <FlowBuilderInputModal
        open={modalAddInput}
        onSave={inputAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddInput}
      />
      <FlowBuilderAddKanbanModal
        open={modalAddKanban}
        onSave={addKanbanAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalAddKanban}
      />
      <FlowBuilderRemoveKanbanModal
        open={modalRemoveKanban}
        onSave={removeKanbanAdd}
        data={dataNode}
        onUpdate={updateNode}
        close={setModalRemoveKanban}
      />
      <FlowBuilderConditionCompareModal
        open={modalAddConditionCompare}
        onSave={conditionCompareAdd}
        data={dataNode?.type === "conditionCompare" ? dataNode : null}
        onUpdate={updateNode}
        close={() => setModalAddConditionCompare(null)}
        nodes={nodes}
      />
    </div>
  );
};
